"use client";

import Image from "next/image";

export default function TigerLoader() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0, // cleaner than top/left/width/height
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
        zIndex: 99999,
      }}
    >
      <Image
        src="/gif/loader3.gif"
        alt="Loading..."
        width={200}
        height={200}
        priority
        unoptimized // ✅ IMPORTANT for GIF
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
    </div>
  );
}
